import { Text } from '@mantine/core';

import Linkv2 from '@/components/content/link/Linkv2';

import { useAuth } from '@/hooks/useAuth';
import { BLUEMINE_BASE_URL } from '@/constants/env';
import { ACCESS_ROLES } from '@/constants/permissions';

import { buildBluemineLinkUrl } from './buildBluemineLinkUrl';
import type { BluemineCatalogSlug } from './bluemineCatalogSlugs';

type OpsLinkProps =
  | {
      id: string | number;
      template: 'issue';
    }
  | {
      id: string | number;
      template: 'catalog';
      catalogSlug: BluemineCatalogSlug;
    };

const OpsLink = (props: OpsLinkProps) => {
  const isAnalyst = useAuth().getIsRole(ACCESS_ROLES.ROLE_ANALYST);

  if (!isAnalyst) return null;

  const { id, template } = props;

  let url: string;
  if (template === 'issue') {
    url = buildBluemineLinkUrl(BLUEMINE_BASE_URL, { template: 'issue', id });
  } else {
    const { catalogSlug } = props;
    url = buildBluemineLinkUrl(BLUEMINE_BASE_URL, {
      template: 'catalog',
      id,
      catalogSlug,
    });
  }

  return (
    <Text size="xs" span>
      <Linkv2 href={url} target="_blank" rel="noreferrer" renderAsInternal>
        {url}
      </Linkv2>
    </Text>
  );
};

export default OpsLink;
